import { forwardRef, type Ref, type SVGProps } from "react";
const IconGasStationFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 4a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v14h2c.825 0 1.567.402 2.082.918.515.515.918 1.257.918 2.082v4c0 .351.09.596.206.735.089.107.285.265.794.265s.705-.158.794-.265c.116-.14.206-.384.206-.735v-8h-1a1 1 0 0 1-1-1v-3a3 3 0 0 1 3-3h.5l.43-2.582A.5.5 0 0 1 28.424 7h.486a.5.5 0 0 1 .493.582L29 10h.424a.5.5 0 0 1 .494.57l-.795 5.571a1 1 0 0 1-.99.859H28v8c0 .649-.16 1.404-.67 2.015-.535.643-1.34.985-2.33.985s-1.795-.342-2.33-.985C22.16 26.405 22 25.65 22 25v-4c0-.175-.098-.433-.332-.668S21.175 20 21 20h-2v3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm11 10.3a3.5 3.5 0 0 1-7 0C8 11.5 11.5 8 11.5 8s3.5 3.5 3.5 6.3m12.903-1.718A.5.5 0 0 0 27.41 12H27a1 1 0 0 0-1 1v1.5a.5.5 0 0 0 .5.5h.576a.5.5 0 0 0 .494-.418z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconGasStationFilledSVG);
ForwardRef.displayName = "IconGasStationFilled";
export { ForwardRef as IconGasStationFilled };
